import Helpers from "../helperFunctions";

/**
 * List of market types having p1 x p2 events
 * @type {string[]}
 */
export const P1XP2MarketTypes = ["P1XP2", "P1P2", "MatchWinner", "MatchResult"];

/**
 * Checks if game has X (draw) market
 * @param {Object} game game object
 * @returns {boolean}
 */
export function hasXMarket (game) {
    return getPrimaryMarketType(game) === "P1XP2";
}

/**
 * Checks if game has P1 or P2 marketsList
 * @param {Object} game game object
 * @returns {boolean}
 */
export function hasP1P2Market (game) {
    var primaryMarketType = getPrimaryMarketType(game);
    return P1XP2MarketTypes.indexOf(primaryMarketType) !== -1;
}

/**
 * Returns game's first market type
 * @param {Object} game game object
 * @returns {String|null}
 */
export function getPrimaryMarketType (game) {
    var market = game && Helpers.firstElement(game.market);
    return market && market.type;
}

/**
 * Returns number of game's additional marketsList with "+" sign or null if there are no additional marketsList
 * @param {Object} game game object
 * @returns {String|null}
 */
export function additionalMarketsCount (game) {
    let alreadyShown = hasP1P2Market(game) ? 1 : 0;
    return game.markets_count - alreadyShown > 0 ? "+" + (game.markets_count - alreadyShown) : "+0";
}